// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
export class ForceUpdateNotificationScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
        this.center();
    }
    localize() {
        void this.set({
            header: Resources.getResource('screen.updateNotification.header')
        });
    }
}
TerceraWindowBase.extendWith(ForceUpdateNotificationScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: true,
            showFooter: false,
            resizable: false,
            canSelect: false,
            focused: true,
            center: true,
            alwaysMiddle: true,
            showFullscreenCloud: true,
            closeBtnVisible: false,
            width: 300,
            style_addition_body: 'screen-body adaptive-height',
            style_addition_jsWin: 'force-update-screen'
        };
    },
    partials: {
        bodyPartial: '<reactUpdateNotificationScreen isForceUpdate="true" />'
    }
});
